import { withTranslation } from 'react-i18next'
import Pricing from './Pricing'

export default withTranslation()(Pricing)
